import { authApi } from 'api';

/**
 * Get volunteer hours target configuration for a club/season
 * @param {string} clubId - The club ID
 * @param {string} seasonId - The season ID
 * @returns {Promise} - The response from the API
 */
export const getVolunteerHoursTargetConfig = async (clubId, seasonId) => {
  try {
    const response = await authApi.get(
      `/clubs/${clubId}/seasons/${seasonId}/volunteer-hours-targets/config`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

/**
 * Save volunteer hours target configuration for a club/season
 * @param {string} clubId - The club ID
 * @param {string} seasonId - The season ID
 * @param {Object} config - The configuration object
 * @param {string} config.targetType - The strategy type: "AgeGroupBased" | "FlatRate" | "TieredByAthleteCount"
 * @param {string} config.configurationJson - The JSON string containing strategy-specific configuration
 * @returns {Promise} - The response from the API
 */
export const saveVolunteerHoursTargetConfig = async (clubId, seasonId, config) => {
  try {
    const response = await authApi.post(
      `/clubs/${clubId}/seasons/${seasonId}/volunteer-hours-targets/config`,
      config
    );
    return response;
  } catch (err) {
    throw err;
  }
};

/**
 * Trigger recalculation of volunteer hours targets
 * @param {string} clubId - The club ID
 * @param {string} seasonId - The season ID
 * @param {Array<string>} userIDs - Optional array of user IDs to recalculate. If omitted, recalculates all members
 * @returns {Promise} - The response from the API
 */
export const recalculateVolunteerHoursTargets = async (clubId, seasonId, userIDs = null) => {
  try {
    const response = await authApi.post(
      `/clubs/${clubId}/seasons/${seasonId}/volunteer-hours-targets/recalculate`,
      { userIDs }
    );
    return response;
  } catch (err) {
    throw err;
  }
};
